import { Link } from 'react-router';
import { isMenuViewKey } from '@/domain';
import { useSession } from '@/application/usecases/useSession';
import { strings } from '@/shared/strings';
import { navItemsFor } from '@/ui/layout/navItems';
import { WidgetSection } from '../WidgetSection';
import { useWidgetBoard } from '../widgetBoardContext';
import board from '../WidgetBoard.module.css';

const text = strings.dashboard;

/**
 * The person's own screens, one press away: every screen their session lists,
 * in the order their menu has them, but for the one they are on.
 *
 * Read off the session, as the menu and the phone's tab bar are, so a screen
 * given to a role or to one person is here on their next visit and one taken
 * away is gone. On a phone the tab bar shows five screens and the rest are a
 * menu away: this is the rest, on the first screen the person sees.
 */
export function ShortcutsWidget() {
  const { data: session } = useSession();
  const here = useWidgetBoard()?.screen;

  const screens = (session?.views ?? []).filter(isMenuViewKey).filter((view) => view !== here);
  const title = text.widgets.shortcuts.title;

  return (
    <WidgetSection label={text.kicker.goTo} title={title}>
      <nav className={board.shortcuts} aria-label={title}>
        {navItemsFor(screens).map((item) => (
          <Link key={item.view} to={item.path} className={board.shortcut}>
            <span className={board.shortcutIcon}>{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
    </WidgetSection>
  );
}
